import _ from "lodash"

import { Currency } from "@costory/types/prisma-client"

import { formatNumber } from "@costory/shared/utils/format"

export interface FormatedTdProps
  extends Omit<React.HTMLProps<HTMLTableCellElement>, "data" | "children"> {
  data?: number | null
  currency?: Currency
  formatForDelta?: boolean
  isBusinessMetric?: boolean
}

export const FormatedTd = ({
  data,
  currency,
  formatForDelta = false,
  isBusinessMetric = false,
  ...props
}: FormatedTdProps) => {
  const formatedData = _.isNumber(data)
    ? formatNumber({
        value: data,
        numberType: currency ? "currency" : "decimal",
        ...(isBusinessMetric && { extraDigits: 2 }),
        currency,
      })
    : "-"

  return (
    <td
      {...props}
      style={{
        padding: 4,
        textAlign: "center",
        color:
          formatForDelta && _.isNumber(data)
            ? data < 0
              ? "red"
              : "green"
            : "black",
        ...props.style,
      }}
    >
      {formatedData}
    </td>
  )
}
